/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.user.progress.rpc.AchievementChirpService
 */

/**
 * Virtual record for map with known enum keys
 */

/**
 * Virtual record for map with known enum keys
 */

/**
 * Virtual record for map with known enum keys
 */

export const createAchievementRpc = {
  serviceName: 'com.hubspot.learning.center.user.progress.rpc.AchievementChirpService',
  rpcName: 'createAchievement',
  auth: 'app',
  fingerprint: 'j_a8fJq_0j8j7GFsdAXYpGXkIH50gY-_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAchievementVisibilityRpc = {
  serviceName: 'com.hubspot.learning.center.user.progress.rpc.AchievementChirpService',
  rpcName: 'updateAchievementVisibility',
  auth: 'app',
  fingerprint: 'KP5ZJX2Empgj7GFsdAXYpGXkIH50gY-_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllAchievementsRpc = {
  serviceName: 'com.hubspot.learning.center.user.progress.rpc.AchievementChirpService',
  rpcName: 'getAllAchievements',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADpZ0RcKUA1mmXkIH50gY-_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};